var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(!_vm.isSupport),expression:"!isSupport"}],staticClass:"vft-screen-orientation"},[_c('div',{staticClass:"horizontal_screen"},[_c('i',{staticClass:"icon_phone"}),_c('p',{staticClass:"desc_txt"},[_vm._v("为了更好的体验，请使用"+_vm._s(_vm.orientation == 'portrait' ? '横' : '竖')+"屏浏览")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }